module.exports = __webpack_public_path__ + "static/banner-tablet-09bfa2b554be5ac02284be33431784d2.png";